export default {
  title: 'Rapport signé / en ligne',
  column_groups: {
    current_period: 'Période actuelle',
  },
  fields: {
    name: 'Nom',
    area: 'Zone',
    signed: 'Signé',
    live: 'En ligne',
    going_live: 'Mise en ligne',
    going_live_avg: 'Moy. mise en ligne',
    churned: 'Résilié',
    not_live: 'Hors ligne',
    live_ratio: 'Taux en ligne',
    avg_mrr: 'MRR moy.',
  },
  manager_status_filters: {
    active: 'Actif',
    inactive: 'Inactif',
    all: 'Tous',
  },
  status_filters: {
    all: 'Tous',
    not_live: 'Hors ligne',
  },
  drawer: {
    title: '{{column}} — {{managerName}}',
    subtitle_one: '{{count}} restaurant',
    subtitle_other: '{{count}} restaurants',
    empty: 'Aucun restaurant trouvé.',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données, veuillez rafraîchir la page',
  },
};
